import { render, staticRenderFns } from "./I2IconButton.vue?vue&type=template&id=0a45dfe2"
import script from "./I2IconButton.vue?vue&type=script&lang=js"
export * from "./I2IconButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports